import { createContext } from "react";

export const VideoWizardContext = createContext(null);
